import React, { useState, useEffect, useRef, useMemo } from 'react';
import './PosterCarousel.css';

const PosterCarousel = () => {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);
  const [fadeIn, setFadeIn] = useState(false);
  const videoRef = useRef(null);
  
  const videoSource = useMemo(() => ({
    mobile: "https://videos.adcionline.com/1.mp4",
    desktop: "https://videos.adcionline.com/2.mp4"
  }), []);

  const currentVideoSource = useMemo(() => 
    isMobile ? videoSource.mobile : videoSource.desktop
  , [isMobile, videoSource]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    setFadeIn(true);

    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, [isMobile]);

  return (
    <div className="poster-carousel-container">
      <video
        ref={videoRef}
        className={`poster-carousel ${fadeIn ? 'carousel-fade-in' : ''}`}
        key={currentVideoSource}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
      >
        <source src={currentVideoSource} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default PosterCarousel;